import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ProductCardComponent } from '../components/product-card/product-card.component';
import { CategoryPageAbstract } from '../../common/category-page.abstract';
import { ObserverDirective } from 'src/app/shared/directives/observer/observer.directive';
import { ScrollListDirective } from 'src/app/shared/directives/scroll-list/scroll-list.directive';
import { ScrollItemDirective } from 'src/app/shared/directives/scroll-list/scroll-item.directive';

@Component({
  selector: 'app-fresh-category-page',
  templateUrl: './fresh-category-page.component.html',
  styleUrls: ['./fresh-category-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    RouterOutlet,
    ProductCardComponent,
    ObserverDirective,
    ScrollListDirective,
    ScrollItemDirective
  ]
})
export class FreshCategoryPageComponent extends CategoryPageAbstract {
  searchString$: Observable<string | null> = this.menuListRepository.searchString$;
}
